import { render, staticRenderFns } from "./UserContactList.vue?vue&type=template&id=5a57aeef&"
import script from "./UserContactList.vue?vue&type=script&lang=js&"
export * from "./UserContactList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports